var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"div0"},[_c('v-img',{staticClass:"cursorhand",attrs:{"src":require("../assets/img/data-icon.png"),"width":"20px"},on:{"click":function($event){return _vm.prepareData()}}}),_vm._v(" Data ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }